import type { FaireProductEntity } from "../../entity_types/product";

export const p_xg57j3vxbc: FaireProductEntity = {
  token: "p_xg57j3vxbc",
  type: "product",
  name: "Child of God Baby Sleep Swaddle 100% Organic Cotton",
  brandToken: "b_d4x38vshjr",
  brandName: "LollyBanks",
  imageUrl: "https://cdn.faire.com/fastly/97ac63e24fb4d08b880d39eb542e49c801940986a98b5c555f6d770ac0dd92c5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6d5532c83866016ac7b13613c8814f72867040be4d61a9c55f40ce93c5034ba7.jpeg",
    "https://cdn.faire.com/fastly/2d5868d7ea4c3fcd34794375c96959c88fb6e22956b355ce71471c577b8f5952.jpeg",
    "https://cdn.faire.com/fastly/e7333d44044f45e4e6d5ef69aaa510af7678c72cdc339b4432bf2e56a4be4114.jpeg",
    "https://cdn.faire.com/fastly/0e7ed2f4c5d7b40244b553de59e28d54d94c50b32fd4e7d4b7a3838a654b18e7.jpeg",
    "https://cdn.faire.com/fastly/58250d015363af721f4dfd043bc187e193e4ba37ad35f310503ac866f3094d58.jpeg"
  ],
  priceDollars: 7.99,
  description: "PURE ORGANIC COTTON: Our baby sleep swaddle is made from premium organic cotton, ensuring a soft and gentle touch on your baby's delicate skin. \nEASY CHANGE ZIPPER: The thoughtfully designed zipper allows for easy diaper changes without disturbing your baby's sleep.\nHOOK AND LOOP CLOSURES- The hook-and-loop closures keep the swaddle securely in place, providing your baby with safe and comforting support.\nTOG 0.5 RATING: This sleep swaddle comes with a TOG 0.5 rating, making it ideal for warmer climates or seasons. It provides just the right amount of warmth to keep your baby snug without overheating, promoting a restful night's sleep. Closing the wings can upgrade the TOG to 1.0, ensuring optimal comfort.\nCHILD OF GOD CHRISTIAN THEME: This Christian theme gender-neutral design is perfect for both baby girls and boys, making bedtime a joyful experience.\nSUITABLE FOR BABIES 0-6 MONTHS: Two size options are available.",
  tags: [],
  msrpDollars: 16.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:14.707Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
